"use client";

import { useLingui } from "@lingui/react/macro";
import type { CountryValue } from "@offstreetparking/geography";
import { offstreetClient } from "../../api/client";
import { useCompany } from "../../providers/company";
import { VehicleForm } from "./VehicleForm";
import { VehicleModal } from "./VehicleModal";
import { useVehicleSubmitError } from "./useVehicleSubmitError";
type CreateVehicleModalProps = {
	isOpen: boolean;
	shouldDefault: boolean;
	country?: CountryValue;
	defaultState?: string;
	onSuccess: NonNullable<Parameters<typeof offstreetClient.parkers.addParkerVehicle.useMutation>[0]>["onSuccess"];
	onClose: () => void;
};
export const CreateVehicleModal = ({
	isOpen,
	shouldDefault,
	country: countryProp,
	defaultState,
	onSuccess,
	onClose,
}: CreateVehicleModalProps) => {
	const { t } = useLingui();
	const { company } = useCompany();
	const addVehicleMutation = offstreetClient.parkers.addParkerVehicle.useMutation({
		onSuccess,
	});
	const submitError = useVehicleSubmitError(addVehicleMutation.error);
	const country = countryProp ?? company?.country;
	if (!country) {
		return null;
	}
	return (
		<VehicleModal isOpen={isOpen} onClose={onClose} title={t`Add Vehicle`}>
			<VehicleForm
				country={country}
				initialValues={{
					plate: "",
					state: defaultState ?? company?.state ?? "",
					nickname: "",
					isDefault: shouldDefault,
				}}
				isSubmitting={addVehicleMutation.isPending}
				onCancel={() => onClose()}
				onSubmit={async (values) => {
					await addVehicleMutation.mutateAsync({
						plate: values.plate ?? "",
						state: values.state ?? "",
						nickname: values.nickname?.trim() || null,
						isDefault: values.isDefault,
					});
				}}
				submitError={submitError}
				nicknameLabel={t`Nickname`}
				defaultVehicleLabel={t`Default Vehicle`}
			/>
		</VehicleModal>
	);
};
